export class Conditionizer {
  static set(form: any) {
    return new Conditionizer(form);
  }

  public form: any;

  constructor(form: any) {
    this.form = form;
  }

  public isBeingUsedOrHasCondition(fieldName: string) {
    var isUsed = false;
    if (this.form[fieldName].conditions) {
      return true;
    }
    for (var i in this.form) {
      var field = this.form[i];
      if (field.conditions) {
        for (var x in field.conditions) {
          if (field.conditions[x].field === fieldName) {
            isUsed = true;
          }
        }
      }
    }

    return isUsed;
  }

  public findCondition(field: any, name: string) {
    var found = [];
    if (field.conditions) {
      for (var i in field.conditions) {
        if (field.conditions[i].property === name) {
          found.push(field.conditions[i]);
        }
      }
    }
    return found;
  }

  public replaceOperator(operator: string) {
    switch (operator) {
      case "null":
        return "empty";
      case "!null":
        return "notempty";
      case "==":
        return "equal";
      case "$eq":
        return "equal";
      default:
        return operator;
    }
  }

  public getProps(fieldName: string, values: any): any {
    let field = this.form[fieldName];
    const reference: any = this;
    var conditionResults: any = {};
    if (!field) {
      alert(fieldName);
      return null;
    }
    if (field?.conditions) {
      const { conditions } = field;
      for (const condition of conditions) {
        if (condition.method && condition.property && condition.cases) {
          const { cases }: any = condition;
          for (const conditionCase of cases) {
            const methodName = conditionCase.operator + "FieldCondition";
            var fieldValue = values[conditionCase.field];
            if (fieldValue && typeof fieldValue === "string") {
              fieldValue = fieldValue.replace(/<[^>]*>?/gm, "");
            }
            if (!field.__conditions) {
              field.__conditions = {};
            }
            field.__conditions[conditionCase.field] = fieldValue;
            if (
              reference[methodName] &&
              typeof reference[methodName] === "function"
            ) {
              const result = reference[methodName](
                fieldValue,
                conditionCase.value ?? undefined
              );
              if (typeof condition.value === "boolean") {
                if (!conditionResults[condition.property]) {
                  conditionResults[condition.property] = {};
                }
                if (!conditionResults[condition.property][condition.method]) {
                  conditionResults[condition.property][condition.method] = [];
                }
                conditionResults[condition.property].value = condition.value;
                conditionResults[condition.property][condition.method].push(
                  result
                );
              }
            } else {
            }
          }
        }
      }
    }
    for (var property in conditionResults) {
      var condition = conditionResults[property];
      if (condition.$or) {
        var isTrue =
          condition.$or.filter((item: any) => item === true).length > 0;

        if (
          condition.value !== undefined &&
          typeof condition.value === "boolean"
        ) {
          field[property] = isTrue ? condition.value : !condition.value;
        }
      }
    }
    field.__conditions = conditionResults;
    return field;
  }

  public isFieldCondition(fieldValue: any, equalValue: any) {
    if (typeof fieldValue === "string") {
      fieldValue = fieldValue.toLocaleUpperCase();
    }
    if (typeof equalValue === "string") {
      equalValue = equalValue.toLocaleUpperCase();
    }
    return fieldValue && fieldValue === equalValue ? true : false;
  }

  public notFieldCondition(fieldValue: any, equalValue: any) {
    if (typeof fieldValue === "string") {
      fieldValue = fieldValue.toLocaleUpperCase();
    }
    if (typeof equalValue === "string") {
      equalValue = equalValue.toLocaleUpperCase();
    }

    return fieldValue &&
      fieldValue.toString().toLocaleLowerCase() !==
        equalValue.toString().toLocaleLowerCase()
      ? true
      : false;
  }

  public gtFieldCondition(fieldValue: string | number | boolean, gtValue: any) {
    if (typeof fieldValue === "string" || typeof fieldValue === "boolean") {
      fieldValue = fieldValue.toString().length;
    }
    try {
      if (typeof gtValue === "string") {
        gtValue = parseInt(gtValue);
      }
      return fieldValue && fieldValue > gtValue ? true : false;
    } catch (e) {
      return false;
    }
  }

  public equalFieldCondition(fieldValue: any, equalValue: any) {
    if (fieldValue) {
      if (typeof fieldValue !== "string") {
        fieldValue = fieldValue.toString();
      }
    }
    if (fieldValue && typeof fieldValue === "string") {
      fieldValue = fieldValue.toLocaleUpperCase();
    }
    if (equalValue && typeof equalValue === "string") {
      equalValue = equalValue.toLocaleUpperCase();
    }
    return fieldValue && fieldValue === equalValue ? true : false;
  }

  public notemptyFieldCondition(fieldValue: any) {
    return fieldValue && fieldValue.toString().length > 0 ? true : false;
  }

  public emptyFieldCondition(fieldValue: any) {
    return !this.notemptyFieldCondition(fieldValue);
  }

  public likeFieldCondition(fieldValue: any, parameter: any) {
    var matchRegex = "^" + parameter.split("%").join(".*") + "$";

    var regex = new RegExp(matchRegex);
    return regex.test(fieldValue);
  }

  public $eq(fieldValue: any, parameter: any) {
    return this.equalFieldCondition(fieldValue, parameter);
  }

  public eqFieldCondition(fieldValue: any, parameter: any) {
    return this.equalFieldCondition(fieldValue, parameter);
  }

  public $like(fieldValue: any, parameter: any) {
    return this.likeFieldCondition(fieldValue, parameter);
  }
}
